import React, { Component, Fragment } from 'react';
import { Pagination } from 'antd';
import styles from './index.module.scss';
import axios from '@/util/axios';
import { api } from '@/routes/api';
import { connect } from 'react-redux';
import { changeLoading } from '@/redux/base.redux';

@connect(
  null,
  { changeLoading }
)
class index extends Component {
  state = {
    page: 1,
    limit: 10,
    count: 0,
    list: []
  }
  componentDidMount = () => {
    this.getList();
  }
  getList = async (page = this.state.page, limit = this.state.limit) => {
    this.props.changeLoading(true);
    const res = await axios.post(api.getRecruitList, { page, limit });
    const { count, data: list } = res.data;
    list.map(v => v.hidden = true);
    this.setState({ count, list, page, limit });
    setTimeout(() => this.props.changeLoading(false), 500);
  }
  handleShowInfo = (index) => {
    this.setState(prevState => {
      const list = prevState.list;
      list[index].hidden = !list[index].hidden;
      return { list };
    })
  }
  render() {
    const { list, count, page } = this.state;
    return (
      <Fragment>
        <div className={`${styles.banner} ${styles.top_banner}`}>
          <img
            className={styles.banner_img}
            src="/images/top_banner.jpg"
            alt="banner"
          />
        </div>
        <div className={styles.container}>
          <div className={styles.jobList}>
            <div className={styles.header}>
              <span className={styles.position}>职位名称</span>
              <span className={styles.num}>招聘人数</span>
              <span className={styles.duty}>职位性质</span>
              <span className={styles.workplace}>工作地点</span>
            </div>
            {list.map((v, i) => (
              <Fragment key={v.id}>
                <div className={styles.item}>
                  <span className={styles.position}>{v.position}</span>
                  <span className={styles.num}>{`${v.num}人`}</span>
                  <span className={styles.duty}>{v.duty}</span>
                  <span className={styles.workplace}>{v.workplace}</span>
                  <span className={styles.showDetail} onClick={() => this.handleShowInfo(i)}>工作详情</span>
                </div>
                <div className={`${styles.info} ${v.hidden ? styles.hidden : ''}`}>
                  <div className={styles.dutyDesc}>岗位职责：{v.duty_desc ? '' : '暂无岗位职责'}</div>
                  {v.duty_desc ? <p className={styles.preLine}>{v.duty_desc}</p> : null}
                  <div className={styles.qualification}>任职资格：{v.qualification ? '' : '暂无任职资格'}</div>
                  {v.qualification ? <p className={styles.preLine}>{v.qualification}</p> : null}
                </div>
              </Fragment>
            ))}
            <div style={{ textAlign: "right", marginTop: 30 }}>
              <Pagination
                size="small"
                current={page}
                total={count}
                showTotal={total => `共 ${total} 条`}
                defaultPageSize={this.state.limit}
                pageSizeOptions={[10, 20, 30, 40, 50]}
                hideOnSinglePage
                showSizeChanger
                showQuickJumper
                onChange={(page, pageSize) =>
                  this.getList(page, pageSize)
                }
                onShowSizeChange={(current, size) =>
                  this.getList(current, size)
                }
              />
            </div>
          </div>
        </div>

        <div className={styles.app_container}>
          {list.map((v, i) => (
            <div className={styles.app_item} key={v.id} onClick={() => this.handleShowInfo(i)}>
              <div className={styles.app_detail}>
                <span className={styles.app_position}>{v.position}</span>
                <span className={styles.app_num}>{`${v.num}人`}</span>
              </div>
              <div className={styles.app_duty}>{v.duty}</div>
              <div className={`${styles.app_open} ${v.hidden ? '' : styles.hidden}`}>
                <span className={styles.app_workplace}>{v.workplace}</span>
                <span className={styles.app_showDetail}>
                  <img src="/images/arrow-right.png" alt=""/>
                </span>
              </div>
              <div className={`${styles.app_info} ${v.hidden ? styles.hidden : ''}`}>
                <div className={styles.app_dutyDesc}>岗位职责：{v.duty_desc ? '' : '暂无岗位职责'}</div>
                {v.duty_desc ? <p className={styles.app_preLine}>{v.duty_desc}</p> : null}
                <div className={styles.app_qualification}>任职资格：{v.qualification ? '' : '暂无任职资格'}</div>
                {v.qualification ? <p className={styles.app_preLine}>{v.qualification}</p> : null}
              </div>
            </div>
          ))}
        </div>
        <div style={{ height: 80 }}></div>
        <div className={styles.app_footer}>
          <div className={styles.app_img_container}>
            <img src="/images/logo.png" alt=""/>
          </div>
          <div className={styles.app_info_container}>
            <div className={styles.app_info}>
              <div>杭州雅集茶具有限公司</div>
              <a href="http://beian.miit.gov.cn" target="_black" style={{ color: 'rgba(0, 0, 0, .65)' }}>浙ICP备11028005号-2</a>
            </div>
            <div className={styles.app_info}>
              <div>雅集专线:0571-86551555</div>
              <div>浙公网安备 33010802004971号</div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default index;
